/**
 * FooterReveal.js
 */


export default class FooterReveal {

    constructor() {

        this.mainContent = document.getElementById('content');
        this.footer = document.getElementById('footer');
        this.mainContent.style.marginBottom = `${this.footer.offsetHeight}px`;

    }

}
